import React from "react"
import { HashRouter as Router } from "react-router-dom"
import { renderRoutes, routes } from "./routeConfig"
import { LocaleProvider } from "antd"
import zhCN from "antd/lib/locale-provider/zh_CN"
import "moment/locale/zh-cn"

import "./App.scss"

function WayzCloud() {
  return (
    <LocaleProvider locale={zhCN}>
      <Router> {renderRoutes(routes)}</Router>
    </LocaleProvider>
  )
}

export default WayzCloud
